import { configureStore } from "@reduxjs/toolkit";
import localforage from "localforage";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { APP_NAME, APP_REDUCER, PERSIST_BLACKLIST_REDUCERS } from "src/config";

export const makeStore = () => {
  const persistConfig = {
    key: APP_NAME + "-store",
    storage: localforage,
    blacklist: PERSIST_BLACKLIST_REDUCERS,
  };
  const persistedReducer = persistReducer(persistConfig, APP_REDUCER);
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
